import { Box, Typography } from '@mui/material'
import { formatCurrency } from '../../../utils'
import { flexJustifySpaceBetween } from '../../../theme/styleConstants'
import { format } from 'date-fns'
import { FC } from 'react'
import { BillDetail } from '../../../interfaceTypes/common'
import { PaymentAllocationBalanceEffect } from '../../../../generated'

type PaymentAllocation = NonNullable<NonNullable<BillDetail>['paymentAllocations']>[number]

interface BillPaymentsProps {
  paymentAllocations: PaymentAllocation[]
}

const BillPayments: FC<BillPaymentsProps> = ({ paymentAllocations }) => {
  const clientFunds = paymentAllocations.filter(paymentAllocation => !!paymentAllocation.payment?.linkedPayment?.id)
  const clientPayments = paymentAllocations.filter(paymentAllocation => !paymentAllocation.payment?.linkedPayment?.id)

  return (
    <Box mt={1.5}>
      {clientFunds.length > 0 && (
        <Box mb={1.5}>
          <Typography fontWeight={700} mb={0.5}>
            Client Funds
          </Typography>
          {clientFunds.map(payment => (
            <Box key={payment.id} sx={{ ...flexJustifySpaceBetween }}>
              <Typography fontSize="12px">{format(new Date(payment.paymentDate), 'MM/dd/yyyy')}</Typography>
              <Typography fontSize="12px">-{formatCurrency(payment.amount)}</Typography>
            </Box>
          ))}
        </Box>
      )}

      {clientPayments.length > 0 && (
        <>
          <Typography fontWeight={700} mb={0.5}>
            Payments Recieved
          </Typography>
          {clientPayments.map(payment => (
            <Box key={payment.id} sx={{ ...flexJustifySpaceBetween }}>
              <Typography fontSize="12px">{format(new Date(payment.paymentDate), 'MM/dd/yyyy')}</Typography>
              <Typography fontSize="12px">
                {payment.balanceEffect === PaymentAllocationBalanceEffect.Decrease && '-'}{' '}
                {formatCurrency(payment.amount)}
              </Typography>
            </Box>
          ))}
        </>
      )}
    </Box>
  )
}

export default BillPayments
